import axios from 'axios'
import { trackPromise } from 'react-promise-tracker';
import * as CommonVariables from '../../../Common/CommonVariables'

export const GetSubMenuList_ByMenuId = async(Menu_Id) => {
    var result = await trackPromise(
        axios.get(CommonVariables.API_DOMAIN + `SubMenu/GetSubMenuList_ByMenuId?Menu_Id=${Menu_Id}`), 
        CommonVariables.API_HEADER
    ).then(response => response)
    return result;
}

export const ActivateDeActivateSubMenu = async(Id, IsActive) => {
    //debugger;
    var result = await trackPromise(
        axios.get(CommonVariables.API_DOMAIN + `SubMenu/ActivateDeActivateSubMenu?SubMenuId=${Id}&IsActive=${IsActive}`),
        CommonVariables.API_HEADER
    ).then(response => response)
    return result;
}

export const UpdateSubMenu = async(submenuDet) =>{
    var result = await trackPromise(
        axios.post(CommonVariables.API_DOMAIN + 'SubMenu/UpdateSubMenu', 
        JSON.stringify(submenuDet),
        CommonVariables.API_HEADER)
    ).then(response => response)
    return result;
}

export const CreateNewSubMenu = async (submenuDet) => {
    //debugger;
    var result = await trackPromise(
        axios.post(CommonVariables.API_DOMAIN + `SubMenu/CreateNewSubMenu`, 
        JSON.stringify(submenuDet), 
        CommonVariables.API_HEADER)
        ).then(response => response);
    return result;
}

export const GetMappedUnMappedSubMenu_RoleList = async(menuId, subMenuId) => {
    var result = await trackPromise(
        axios.get(CommonVariables.API_DOMAIN + `SubMenu/GetMappedUnMappedSubMenu_RoleList?menuId=${menuId}&subMenuId=${subMenuId}`),
        CommonVariables.API_HEADER
    ).then(response => response)
    return result;
}

export const GetRoleList_ByMenuId = async(Id) => {
    var result = await trackPromise(
        axios.get(CommonVariables.API_DOMAIN + `SubMenu/GetRoleList_ByMenuId?menuId=${Id}`),
        CommonVariables.API_HEADER
    ).then(response => response)
    return result;
}

export const MapSubMenu_Role = async(SubMenuRoleMappingDet) =>{
    var result = await trackPromise(
        axios.post(CommonVariables.API_DOMAIN + 'SubMenu/MapSubMenu_Role', 
        JSON.stringify(SubMenuRoleMappingDet),
        CommonVariables.API_HEADER)
    ).then(response => response)
    return result;
}